import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import Image from './Image';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { newsBorderColor, tertiaryColor } from 'src/constants/stylesheet';
import { Link } from 'react-router-dom';
import { formatDate } from './Home';
import * as classNames from 'classnames';
import fonts from 'src/constants/fonts';
import Sharer from './Sharer';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      maxWidth: spacing.websiteMaxWidth,
      margin: '0 auto',
      [mediaQueries.Mobile]: {
        paddingTop: spacing.Gutter.Mobile * 2,
        paddingLeft: spacing.Gutter.Mobile,
        paddingRight: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        paddingTop: spacing.Gutter.Tablet * 2,
        paddingLeft: spacing.Gutter.Tablet,
        paddingRight: spacing.Gutter.Tablet,
        paddingBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        paddingTop: spacing.Gutter.Laptop * 2,
        paddingLeft: spacing.Gutter.Laptop,
        paddingRight: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        paddingTop: spacing.Gutter.Desktop * 2,
        paddingLeft: spacing.Gutter.Laptop,
        paddingRight: spacing.Gutter.Laptop,
        paddingBottom: spacing.Gutter.Laptop,
      },
    },
    newsItem: {
      position: 'relative',
      border: `1px solid ${newsBorderColor}`,
      [mediaQueries.Mobile]: {
        marginBottom: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        marginBottom: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        marginBottom: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        marginBottom: spacing.Gutter.Desktop,
      },
    },
    imageContainer: {
      position: 'relative',
      height: 0,
      paddingBottom: '42.55%',
    },
    imageContainerInner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      ...stylesheet.ObjectFitCover,
    },
    newsTextContainer: {
      [mediaQueries.Mobile]: {
        padding: spacing.Gutter.Mobile,
      },
      [mediaQueries.Tablet]: {
        padding: spacing.Gutter.Tablet,
      },
      [mediaQueries.Laptop]: {
        padding: spacing.Gutter.Laptop,
      },
      [mediaQueries.Desktop]: {
        padding: spacing.Gutter.Desktop,
      },
    },
    newsTextContainerInner: {
      display: 'flex',
    },
    newsTextContent: {
      flex: '1 1 auto'
    },
    newsSharerContainer: {
      flex: '0 0 auto',
      position: 'relative',
    },
    newsTitle: {
      ...stylesheet.NewsMainTitle,
    },
    newsTitleMargin: {
      position: 'relative',
      marginBottom: 10
    },
    newsDate: {
      fontSize: '.85rem',
      // paddingBottom: 10,
      color: tertiaryColor,
      ...fonts.light
    },
    text: {
      ...fonts.light,
      color: tertiaryColor,
    },
    link: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  }));
export type NewsProps = NewsDto;

type Props = NewsProps;

const News: FC<Props> = ({ NewsEntries, UID }) => {
  const cls = useStyles();

  const sizes = '(max-width: 1023px) 100vw, 400px'
  
  return (
    <section className={cls.root}>
      {NewsEntries.map(n =>
        <article key={n.UID} className={cls.newsItem}>
          <div className={cls.imageContainer}>
            <div className={cls.imageContainerInner}>
              <Image
                className={cls.image}
                sizes={sizes}
                pictureRef={n.Image}
              />
              <Link to={`/${UID}/${n.UID}`} className={cls.link} />
            </div>
          </div>
          <div className={cls.newsTextContainer}>
            <div className={cls.newsTextContainerInner}>
              <div className={cls.newsTextContent}>
                <div className={cls.newsDate}>{formatDate(n.Date)}</div>
                <h2 className={classNames(cls.newsTitle, cls.newsTitleMargin)}>
                  {n.Title}
                  <Link to={`/${UID}/${n.UID}`} className={cls.link} />
                </h2>
                <div className={cls.text} dangerouslySetInnerHTML={{ __html: n.PreviewText }} />
              </div>
              <div className={cls.newsSharerContainer}>
                <Sharer url={`${window.location.origin}/${UID}/${n.UID}`} />
              </div>
            </div>
          </div>
        </article>
      )}
    </section>
  );
};

export default News;


// WEBPACK FOOTER //
// ./src/Components/News.tsx